import axios from '@lib/axios';
import { useMutation, useQueryClient, } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export interface CategoryInputs {
  contentGroupId: string;
  name: string;
  parentId?: string;
  color?: string;
  subcategoryColor?: string;
  highlightNoteColor?: string;
  active?: boolean;
}

interface SaveRecipientProps {
  contentGroupId: string;
  categoryId?: string;
	onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useSaveTemplateCategory = ({
  contentGroupId,
  categoryId,
	onSuccess,
  onError
}: SaveRecipientProps) => {
  const queryClient = useQueryClient();
	const {
		mutate: onSaveTemplateCategory,
		...rest
	} = useMutation({
		mutationFn: async (inputs: CategoryInputs) => {
      if (categoryId) 
        return axios.patch(`/template-categories/${categoryId}`, inputs);
      return axios.post('/template-categories', inputs);
    },
		onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['categories', { contentGroupId }] });
      if (onSuccess)
        onSuccess(data);
    },
    onError
	});

	return { onSaveTemplateCategory, ...rest };
};
